import enLocale from "element-ui/lib/locale/lang/en"; //引入element-ui中的英文内容


const localEnLocale = {
    ...enLocale,
    title: "Đồng ý",
    userQuestion: "Hỗ trợ Khách hàng",
    transform: "Đến nhân viên",
    message: "Tin nhắn",
    camera: "Hình ảnh",
    file: "Tập tin",
    evaluate: "Đánh giá",
    eval_title: "Tin nhắn",
    eval_desc: " Vấn đề có được giải quyết không ?",
    eval_submit: "Gửi khảo sát",
    msg_title: "Soạn tin nhắn",
    msg_submit: "Gửi tin nhắn",
    msg_desc: "Bạn vui lòng để lại tin nhắn, chúng tôi sẽ liên hệ với bạn trong thời gian sớm nhất",
    sendBtn: "Gửi",
    tips: "Gợi Ý",
    sure: "Đồng ý",
    cancel: "Hủy",
    closeTips: "Bạn có đồng ý ngắt kết nối cuộc trò chuyện hiện tại không?",
    customerInputIng: "Đang truy cập vào Dịch vụ Khách hàng  ...",
    historyChat: "Lịch sử trò chuyện",
    loading: "Đang tải ...",
    noHistory: "Không có lịch sử trò chuyện",
    download: "Tải về",
    input: "Vui lòng nhập",
    orderStatus: "Trạng Thái ",
    orderNumber: "Số thứ tự ",
    showDetail: "Hiển thị chi tiết",
    orderTime: "Thời gian phục vụ",
    thump: "Thích",
    top: "nhấp vào",
    submit: "Gửi",
    pleInput: "Vui lòng nhập",
    content: "Nội dung！",
    rightPhone: "Vui lòng điền đúng số liên lạc！",
    rightEmail: "Vui lòng điền đúng email！",
    emoji: "Biểu tượng emoji",
    leaveMsg: "Tin nhắn",
    uploadFile: "Tải lên tập tin",
    reChat: "Trò chuyện lại",
    chatAfterEva: "Vui lòng đánh giá sau khi hỗ trợ",
    veryGood: "Rất hài lòng, đánh giá năm sao",
    notGood: "Không hài lòng, cần cải thiện",
    userName: "Tên đăng nhập",
    userPhone: "Số liên lạc",
    userEmail: "Email",
    leaveMsgCon: "Nội dung tin nhắn",
    submitLeave: "Gửi tin nhắn",
    getHistory: "Lấy lịch sử",
    isResolved: "Vấn đề của bạn có được giải quyết không？",
    leaveTip: "Gợi ý đánh giá: dịch vụ tốt, chưa đủ tốt, ...",
    leaveInput: "Mong nhận được đánh giá dịch vụ từ Quý Khách",
    solved: "Đã giải quyết",
    noSolved: "Chưa giải quyết",
    submitEva: "Gửi đánh giá",
    noSubmitEvaEndChat: "Không đánh giá t ạm thời đoạn kết",
    evaConInput: "Vui lòng điền nội dung đánh giá!",
    evaLabelSelect: "Vui lòng chọn một loại đánh giá!",
    robotEva1: "Đã giải đáp thắc mắc",
    robotEva2: "Dịch vụ kém",
    robotEva3: "Không thể trả lời câu hỏi",
    robotEva4: "Không hợp lệ",
    customerEva1: "Dịch vụ kém",
    customerEva2: "Trả lời chậm",
    customerEva3: "Không giải quyết được vấn đề",
    customerEva4: "Không hợp lệ",
    leaveMessage: "Sau đây là tin nhắn ngoại tuyến",
    helloMsg: "Xin chào, tôi có thể giúp gì cho bạn",
    noCustomer: "Dịch vụ Hỗ trợ trực tuyến sẽ quay lại sau",
    isSureLeave: "Bạn chắc chắn muốn rời khỏi trang hiện tại không？",
    customer: "Nhân viên",
    customerFirst: "V9Bet xin chào! Vui lòng đợi - đang kết nối bạn đến",
    connectChat: "đang kết nối với bạn",
    busyMessage: "Dịch vụ Khách hàng sẽ quay lại sau",
    transferFailed: "Không thể chuyển sang nhân viên!",
    notWork: "Dịch vụ Khách hàng tạm ngưng!",
    closeChat: "Cuộc trò chuyện của bạn đã kết thúc!",
    newWindow: "Bắt đầu cuộc trò chuyện ở cửa sổ chat mới",
    chatOver: "Cuộc trò chuyện của bạn đã kết thúc",
    backMessage: "Dịch vụ Khách hàng đã rút lại một tin nhắn",
    thankMessage: "Cảm ơn bạn đã đánh giá",
    fileMax: "Dung lượng tối đa 50M!",
    newMessage: "【Bạn đã nhận được một tin nhắn mới 】",
    inputUserName: "Vui lòng nhập tên đăng nhập!",
    inputUserPhone: "Vui lòng điền đúng số liên lạc!",
    inputUserEmail: "Vui lòng điền đúng email!",
    inputLeaveMsg: "Vui lòng nhập nội dung tin nhắn!",
    submitSuc: "Gửi thành công!",
    today: "hôm nay",
    leftMsg : " Tin nhắn " ,
    VeryGood : " Rất hài lòng, khen ngợi năm sao " ,
    leftMsgCon : " Nội dung tin nhắn " ,
    leftMessage : " Sau đây là một tin nhắn ngoại tuyến " ,
    fileTypeError : "Định dạng tập tin không chính xác" ,



}

export default localEnLocale;




// WEBPACK FOOTER //
// ./src/language/vi.js